import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstNameLastName',
    standalone: true
})
export class FirstNameLastNamePipe implements PipeTransform {
    transform(firstName: string | null | undefined, lastName: string | null | undefined): string {
        const trimmedFirstName = (firstName || '').trim();
        const trimmedLastName = (lastName || '').trim();

        if (trimmedFirstName && trimmedLastName) {
            return `${trimmedFirstName} ${trimmedLastName}`;
        } else if (trimmedFirstName) {
            return trimmedFirstName;
        } else if (trimmedLastName) {
            return trimmedLastName;
        } else {
            return '';
        }
    }
}
